import React from 'react';
import BaseComponent from '../../../baseClasses/BaseComponent';
import dataModel from '../../../models/DataModel';

import './SyncSuccessfulBanner.scss';

export default class SyncSuccessfulBanner extends BaseComponent {

  constructor(props) {
    super(props);
    this.state = {
      bannerText: 'You\'re all synced up!',
      shown: false,
    };
    this.closeBanner = this.closeBanner.bind(this);
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({ shown: true });
    }, 10);
    setTimeout(() => {
      this.closeBanner();
    }, 3010);
  }

  closeBanner() {
    return new Promise((resolve) => {
      this.setState({ shown: false });
      // wait for animation to actually close banner
      setTimeout(() => {
        resolve();
        // hide the component
        dataModel.hideGlobalBanner(this.props.bannerType);
      }, 150);
    });
  }
  
  render() {

    return (
      <div className={'sync-banner ' + (this.state.shown ? '' : 'sync-banner--closing')}>
        <div className='sync-banner__text'>{this.state.bannerText}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/banners/SyncSuccessfulBanner/index.js